// src/components/common/BranchRedirect.js
// Redirects /menu, /tables, /reports to the branch-specific routes
// using the selected branch from BranchContext
import React, { useContext, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { BranchContext } from '../../context/BranchContext';

const BranchRedirect = ({ path }) => {

  const { selectedBranch, branches } = useContext(BranchContext);
  const location = useLocation();
  // Use the selected branch, or fall back to the first branch available
  const branch = selectedBranch || (branches && branches.length > 0 ? branches[0] : null);
  const branchId = branch?._id || branch?.id;

  
  if (!branchId) {
    // No branch available — redirect to branches list so user can select one
    return <Navigate to="/branches" replace />;
  }
  
  return <Navigate to={`/branches/${branchId}/${path}`} replace />;
};

export const MenuRedirect = () => <BranchRedirect path="menu" />;
export const TablesRedirect = () => <BranchRedirect path="tables" />;
export const ReportsRedirect = () => <BranchRedirect path="sales-report" />;
export const ExpensesRedirect = () => <BranchRedirect path="expenses" />;

export default BranchRedirect;
